import React from 'react';

import {
  CardRoot,
  ContactInfo,
  ContactName,
  ContactMeta,
  ChangeButton,
} from './styles';

export interface SelectedContactCardProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  /** Nome do contato selecionado. */
  name: string;
  /** Telefone (exibido antes do email). */
  phone: string;
  /** E-mail (exibido após o telefone). */
  email: string;
  /** Disparado ao clicar em "Alterar contato". */
  onChange?: () => void;
  /** Texto do botão de troca. @default 'Alterar contato' */
  changeLabel?: string;
}

/**
 * SelectedContactCard — exibe o contato escolhido em destaque (fundo azul-claro)
 * com nome + "telefone · email" e uma ação "Alterar contato".
 *
 * Aparece no lugar do `ContactSelect` depois que um contato é selecionado.
 *
 * @example
 * <SelectedContactCard
 *   name="Carlos Eduardo Silva"
 *   phone="(11) 9 8765-4321"
 *   email="carlos.silva@email.com"
 *   onChange={() => setSelecionado(null)}
 * />
 */
export const SelectedContactCard = ({
  name,
  phone,
  email,
  onChange,
  changeLabel = 'Alterar contato',
  ...rest
}: SelectedContactCardProps): React.ReactElement => (
  <CardRoot {...rest}>
    <ContactInfo>
      <ContactName>{name}</ContactName>
      <ContactMeta>{`${phone} · ${email}`}</ContactMeta>
    </ContactInfo>
    {onChange && (
      <ChangeButton type="button" onClick={onChange}>
        {changeLabel}
      </ChangeButton>
    )}
  </CardRoot>
);

export default SelectedContactCard;
